import {NgModule} from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {RouterModule} from '@angular/router';
import {MatButtonModule} from '@angular/material/button';
import {MatDividerModule} from '@angular/material/divider';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {FuseNavigationModule} from '@fuse/components/navigation';
import {FuseLoadingBarModule} from '@fuse/components/loading-bar';
import {FuseFullscreenModule} from '@fuse/components/fullscreen/fullscreen.module';
import {LanguagesModule} from 'app/layout/common/languages/languages.module';
import {MessagesModule} from 'app/layout/common/messages/messages.module';
import {NotificationsModule} from 'app/layout/common/notifications/notifications.module';
import {SearchModule} from 'app/layout/common/search/search.module';
import {ShortcutsModule} from 'app/layout/common/shortcuts/shortcuts.module';
import {SharedModule} from 'app/shared/shared.module';
import {ClassyLayoutComponent} from 'app/layout/layouts/vertical/classy/classy.component';

import {SpinnerModule} from "../../../../shared/components/spinner/spinner.module";
import { SelectComuneComponent } from './select-comune/select-comune.component';
import {TranslocoModule} from "@jsverse/transloco";
import {MatSelectModule} from "@angular/material/select";

@NgModule({ declarations: [
        ClassyLayoutComponent,
        SelectComuneComponent
    ],
    exports: [
        ClassyLayoutComponent
    ], imports: [RouterModule,
        MatButtonModule,
        MatDividerModule,
        MatIconModule,
        MatMenuModule,
        FuseFullscreenModule,
        FuseLoadingBarModule,
        FuseNavigationModule,
        LanguagesModule,
        MessagesModule,
        NotificationsModule,
        SearchModule,
        ShortcutsModule,
        SharedModule,
        SpinnerModule,
        TranslocoModule,
        MatSelectModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class ClassyLayoutModule
{
}
